interface SearchProductInputProps {
  searchKeyword: string;
  setSearchKeyword: (value: string) => void;
}

const SearchProductInput = (props: SearchProductInputProps): JSX.Element => {
  const { searchKeyword, setSearchKeyword } = props;
  return (
    <div className="flex justify-center mt-3">
      <div className="flex items-center p-3 w-full sm:w-3/5 md:w-1/2 lg:w-2/5">
        <input
          placeholder="상품명을 입력하세요"
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-transparent transition duration-300 ease-in-out text-gray-700 placeholder-gray-400"
          value={searchKeyword}
          onChange={(e) => setSearchKeyword(e.target.value)}
        ></input>
      </div>
    </div>
  );
};

export default SearchProductInput;
